export default __webpack_public_path__ + "static/media/normal-graph.43b0fe5b.svg";